import ReactECharts from "echarts-for-react";

import { processDetailInstrumentChartData } from "../utils/utils"; // Asegúrate de que la ruta es correcta

import { SkeletonChart } from "./skeletons/productDetail";

export function DetailInstrumentChart({ apiData }) {
    if (!apiData) {
        return <SkeletonChart />;
    }

    // Llama a la función para procesar los datos
    const { xAxisData, seriesData } = processDetailInstrumentChartData(apiData); // Asumiendo que apiData contiene la propiedad 'valuaciones'

    const options = {
        grid: { top: 24, right: 40, bottom: 80, left: 80 },
        xAxis: {
            type: "category",
            data: xAxisData,
        },
        yAxis: {
            type: "value",
        },
        series: [
            {
                data: seriesData,
                type: "line",
            },
        ],
        tooltip: {
            trigger: "axis",
        },
        dataZoom: [
            {
                type: "inside",
                xAxisIndex: [0],
                start: 0,
                end: 100,
            },
            {
                type: "slider",
                xAxisIndex: [0],
                start: 0,
                end: 100,
            },
            {
                type: "inside",
                yAxisIndex: [0],
                start: 0,
                end: 100,
            },
            {
                type: "slider",
                yAxisIndex: [0],
                start: 80,
                end: 100,
                right: 0,
            },
        ],
        toolbox: {
            feature: {
                dataZoom: {
                    yAxisIndex: "none",
                },
                restore: {},
                saveAsImage: {},
            },
        },
    };

    return (
        <div className="cot-lines-chart">
            <ReactECharts option={options} />
        </div>
    );
}
